import { Component, Vue } from 'vue-property-decorator';
import defaultDictionary from './DefaultDictionary';

@Component
export default class Translatable extends Vue {
  public getTranslation(key: string): string {
    const translation = this.$store.getters.translations[key];
    return translation || `[${key}]`;
  }

  public getTranslationOrDefault(key: string, defaultValue: string = null): string {
    const translation = this.$store.getters.translations[key];
    return (
      translation || defaultValue || defaultDictionary.find((d) => d.key === key)?.value || `[${key}]`
    );
  }
}
